































































































































import {
  apiTradeGeneralTradePreOrder,
  ApiTradeGeneralTradePreOrderRequest,
  apiTradeGeneralTradeTradeOrder,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { globalModel } from '@/model'
import { isPossibleChineseMobilePhoneNumber, wait } from 'vtils'
import { JointComponents } from '../components'
import { mall } from '@/mall_jssdk'
import { prepareData, requiredDeep, submit, Track } from '@/utils'
import { redirectTo } from '@/router'
import { UserUtils } from '@/views/user/utils'
import { XPickCouponParams, XPickCouponResult } from '@/components'

export default defineClassComponent(
  {
    components: JointComponents,
  },

  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '提交订单',
        }))
      }

      query = useQuery<{
        /** 预下单请求数据 */
        preOrderRequestData: ApiTradeGeneralTradePreOrderRequest
      }>({
        preOrderRequestData: {
          transformer: JSON.parse,
        },
      })

      orderDate = computed(
        () => this.query.preOrderRequestData.skuInfo[0].stockDate,
      )

      count = ref(1)

      apiData = useApi(
        async () => {
          const { preOrderData, userData } = await prepareData({
            preOrderData: apiTradeGeneralTradePreOrder({
              ...this.query.preOrderRequestData,
              skuInfo: [
                {
                  ...this.query.preOrderRequestData.skuInfo[0],
                  count: this.count.value,
                },
              ],
            }).then(requiredDeep),
            userData: UserUtils.getInfo(),
          })
          this.phoneNumber.value =
            this.phoneNumber.value || userData.phoneNum || ''
          return preOrderData
        },
        {
          refreshOnChange: () => this.count.value,
        },
      )

      preOrderData = computed(() => this.apiData.data)

      orderData = computed(() => this.preOrderData.value.orderInfo[0])

      storeData = computed(() => this.preOrderData.value)

      goodsData = computed(() => this.orderData.value.commodityInfo[0])

      refundData = computed(() => this.orderData.value.writeOffRefund)

      phoneNumber = ref('')

      name = ref('')

      pickCouponParams = computed<XPickCouponParams>(() => ({
        goodsIdList: this.preOrderData.value.orderInfo.reduce<any[]>(
          (res, merchant) => {
            res.push(
              ...merchant.commodityInfo.map(goods =>
                JSON.stringify({
                  id: goods.resourceId,
                  name: goods.commodityName,
                  price: goods.unitPrice,
                  count: goods.count,
                  totalAmt: mall.calculator.sub(
                    goods.totalPrice,
                    goods.discountActivityAmount,
                  ),
                  superimposeDiscountType:
                    this.preOrderData.value.discountItems[0]?.type || null,
                  categoryId: goods.categoryId,
                }),
              ),
            )
            return res
          },
          [],
        ),
        amt: this.preOrderData.value.orderAmount,
        discountedAmt: mall.calculator.add(
          ...this.preOrderData.value.discountItems.map(item => item.amount),
        ),
        businessType: this.preOrderData.value.businessType,
        unitOrgCode: this.preOrderData.value.unitOrgCode,
      }))

      pickCouponResult = ref<XPickCouponResult>({} as any)

      payAmount = computed(() =>
        mall.calculator.sub(
          // 订单金额
          _ => _.mul(this.goodsData.value.unitPrice, this.count.value),

          // 减去优惠券金额
          this.pickCouponResult.value.discountedAmt || 0,

          // 减去折扣优惠金额
          _ =>
            _.add(
              ...this.preOrderData.value.discountItems.map(
                item => item.amount,
              ),
            ),
        ),
      )

      handlePayClick = () => {
        submit(async $ => {
          if (
            !this.phoneNumber.value ||
            !isPossibleChineseMobilePhoneNumber(this.phoneNumber.value)
          ) {
            return $.fail('请输入正确的手机号')
          }
          $.start()
          const payData = await apiTradeGeneralTradeTradeOrder({
            preOrderId: this.preOrderData.value.preOrderId,
            consigneeName: this.name.value,
            consigneeTel: this.phoneNumber.value,
            consigneeAddress: {
              province: '',
              city: '',
              area: '',
              areaCode: '',
              detail: '',
              name: this.name.value,
              phoneNo: this.phoneNumber.value,
            },
            tradeOrderInfo: [
              {
                orderId: this.orderData.value.orderId,
                count: this.count.value,
              },
            ],
            couponId: this.pickCouponResult.value.couponId,
            discountAmount: this.pickCouponResult.value.discountedAmt || 0,
            payType: globalModel.state.payType as any,
            openId: globalModel.state.openid,
          })
          Track.pushEvent({
            type: 'click',
            name: '提交订单',
            id: 'TiJiaoDinDan',
            extra: {
              // @ts-ignore
              order_id: payData.orderId,
              order_price: this.payAmount.value,
              commodity_id: this.preOrderData.value.orderInfo
                .reduce<string[]>((res, merchant) => {
                  res.push(
                    ...merchant.commodityInfo.map(goods => goods.commodityId),
                  )
                  return res
                }, [])
                .join(','),
              commodity_name: this.preOrderData.value.orderInfo
                .reduce<string[]>((res, merchant) => {
                  res.push(
                    ...merchant.commodityInfo.map(
                      goods => goods.commodityName,
                    ),
                  )
                  return res
                }, [])
                .join(','),
              original_price: this.preOrderData.value.orderAmount,
              present_price: this.payAmount.value,
              discount_price:
                this.preOrderData.value.orderAmount - this.payAmount.value,
              submit_type: '立即支付',
            },
          })
          try {
            await dcb.requestPayment({
              provider: 'native',
              showNativeResultPage: false,
              params: payData,
            })
            await wait(1000)
            redirectTo('JointOrderSuccess')
          } catch {
            redirectTo('BookOrderIndex')
          }
        })
      }
    },
)
